unable to read source [project]/node_modules/stripe/src/Decimal.ts